import type { GetResult, ListResult } from "@prolarus/shared";
import { tryGet, tryList } from "./_shared";

export interface UserProfileRow {
  id: string;
  full_name: string | null;
  avatar_url: string | null;
  phone: string | null;
  company_name: string | null;
  email: string;
  last_sign_in_at: string | null;
  deleted_at: string | null;
  auth_created_at: string;
  profile_created: string;
  profile_modified: string;
}

// Mirrors the prior userAdminService. _companyId is preserved for signature
// compat; the route clamps p_company_id to the JWT-derived value.
export const userAdminService = {
  listUsers(_companyId: string): Promise<ListResult<UserProfileRow>> {
    return tryList<UserProfileRow>("/api/users");
  },

  countActiveUsers(_companyId: string): Promise<GetResult<number>> {
    return tryGet<number>("/api/users/active-count");
  },
};
